import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table, Button, Popconfirm, Tooltip, Spin, Typography, Tag } from "antd";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { GrCompliance } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import deleteDataById from "../../../hooks/deleteDataById";
import i18next from "i18next";
import axios from "../../../components/utils/Interceptors";

const { Title } = Typography;

const ProductQueries = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(false);
  const selectLanguage = i18next.language;
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchQueries = async () => {
      setLoading(true);
      try {
        const baseUrl = process.env.REACT_APP_APIURL;
        const res = await axios.get(`${baseUrl}/vendor/getallcustomerquery`, {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });
        const response = res.data;

        if (response.status_code === 200) {
          setQueries(response.data);
        }
      } catch (error) {
        toast.error(t("Error fetching queries"));
      } finally {
        setLoading(false);
      }
    };
    fetchQueries();
  }, [t, user.token]);

  const selectItemToEdit = (id) => {
    navigate("/vendor/update_queries", { state: id });
  };

  const deleteItem = async (id) => {
    try {
      setLoading(true);
      const response = await deleteDataById("vendor/deletecustomerquery", id);
      if (response.status_code === 200) {
        setQueries((prev) => prev.filter((item) => item.id !== id));
        toast.success(t("Deleted successfully"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t("Error deleting query"));
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: t("query_cust_name"),
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
      title: t("query_cust_email"),
      dataIndex: "customer_email",
      key: "customer_email",
    },
    {
      title: t("Query"),
      dataIndex: selectLanguage === "ar" ? "query_ar" : "query",
      key: "query",
    },
    {
      title: t("all_product_dataTable6"),
      key: "resolved_on",
      render: (_, record) =>
        !record.resolution ? (
          <Tag color="orange">{t("Pending")}</Tag>
        ) : (
          <span>{record.resolved_on?.slice(0, 10)}</span>
        ),
    },
    {
      title: t("vd_pc_C_Options"),
      key: "action",
      render: (_, record) => (
        <>
          <Tooltip title={t("Edit")}>
            <Button
              type="default"
              shape="circle"
              icon={record.resolution ? <GrCompliance /> : <AiOutlineEdit />}
              onClick={() => selectItemToEdit(record.id)}
            />
          </Tooltip>
          <Popconfirm
            title={t("delete_alert_title")}
            description={t("delete_alert_des")}
            onConfirm={() => deleteItem(record.id)}
            okText={t("yes")}
            cancelText={t("no")}
            okButtonProps={{
                style: { backgroundColor: "#f4900c", borderColor: "#f4900c", color: "white" }
            }}
          >
            <Tooltip title={t("Delete")}>
              <Button
                type="primary"
                danger
                shape="circle"
                icon={<AiOutlineDelete />}
                style={{ marginLeft: 8 }}
                
              />
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <Title level={4}>{t("Query_all")}</Title>
      <div className="my-5 bg-white border rounded p-4">
        <Spin spinning={loading} tip={t("Loading...")}>
          <Table
            columns={columns}
            dataSource={queries}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            locale={{ emptyText: t("No records") }}
          />
        </Spin>
      </div>
    </div>
  );
};

export default ProductQueries;
